import { __decorate } from "tslib";
import { attr } from '@microsoft/fast-element';
import { FoundationElement } from '@microsoft/fast-foundation';
import { foundationFlyoutStyles as styles } from './flyout.styles';
import { foundationFlyoutTemplate as template } from './flyout.template';
/**
 * @tagname %%prefix%%-flyout
 */
export class Flyout extends FoundationElement {
    constructor() {
        super(...arguments);
        this.position = 'right';
        this.displayHeader = true;
        this.closed = true;
        this.visuallyhidden = true;
    }
    closedChanged() {
        if (!this.closed) {
            // TODO: timeout shouldn't be necessary here but without it opening transition doesn't work
            setTimeout(() => (this.visuallyhidden = false), 1);
        }
    }
    closeFlyout() {
        this.visuallyhidden = true;
    }
    closingFinished() {
        if (this.visuallyhidden) {
            this.closed = true;
            this.$emit('closed');
        }
    }
}
__decorate([
    attr
], Flyout.prototype, "position", void 0);
__decorate([
    attr({ mode: 'boolean' })
], Flyout.prototype, "displayHeader", void 0);
__decorate([
    attr({ mode: 'boolean' })
], Flyout.prototype, "closed", void 0);
__decorate([
    attr({ mode: 'boolean' })
], Flyout.prototype, "visuallyhidden", void 0);
// explicitly declaring for extensibility
export const foundationFlyoutShadowOptions = undefined;
export const defaultFlyoutConfig = {};
/**
 * The Foundation Flyout
 *
 * @public
 * @remarks
 * HTML Element: \<foundation-flyout\>
 */
export const foundationFlyout = Flyout.compose(Object.assign({ baseName: 'flyout', styles,
    template, shadowOptions: foundationFlyoutShadowOptions }, defaultFlyoutConfig));
